module.exports = __webpack_public_path__ + "img/icon-bar-gray.46132126.png";